export const CREATE_TIMESHEET_REQUEST_FAILURE = 'CREATE_TIMESHEET_REQUEST_FAILURE';
export const CREATE_TIMESHEET_REQUEST_SUCCESS = 'CREATE_TIMESHEET_REQUEST_SUCCESS';

export const DUPLICATE_TIMESHEET_REQUEST_SUCCESS = 'DUPLICATE_TIMESHEET_REQUEST_SUCCESS';

export const GET_TIMESHEET_REQUEST = 'GET_TIMESHEET_REQUEST';
export const GET_TIMESHEET_REQUEST_FAILURE = 'GET_TIMESHEET_REQUEST_FAILURE';
export const GET_TIMESHEET_REQUEST_SUCCESS = 'GET_TIMESHEET_REQUEST_SUCCESS';

export const RECALL_TIMESHEET_REQUEST = 'RECALL_TIMESHEET_REQUEST';
export const RECALL_TIMESHEET_REQUEST_FAILURE = 'RECALL_TIMESHEET_REQUEST_FAILURE';
export const RECALL_TIMESHEET_REQUEST_SUCCESS = 'RECALL_TIMESHEET_REQUEST_SUCCESS';

export const RESET_TIMESHEET_STATE = 'RESET_TIMESHEET_STATE';

export const SAVE_TIMESHEET_REQUEST_FAILURE = 'SAVE_TIMESHEET_REQUEST_FAILURE';
export const SAVE_TIMESHEET_REQUEST_SUCCESS = 'SAVE_TIMESHEET_REQUEST_SUCCESS';
export const SAVE_TIMESHEET_REQUEST_ASYNC = 'SAVE_TIMESHEET_REQUEST_ASYNC';
export const SAVE_TIMESHEET_REQUEST_ASYNC_FAILURE = 'SAVE_TIMESHEET_REQUEST_ASYNC_FAILURE';
export const SAVE_TIMESHEET_REQUEST_ASYNC_SUCCESS = 'SAVE_TIMESHEET_REQUEST_ASYNC_SUCCESS';

export const SUBMIT_TIMESHEET_REQUEST_ASYNC_FAILURE = 'SUBMIT_TIMESHEET_REQUEST_ASYNC_FAILURE';
export const SUBMIT_TIMESHEET_REQUEST_ASYNC_SUCCESS = 'SUBMIT_TIMESHEET_REQUEST_ASYNC_SUCCESS';

export const UPDATE_TIMESHEET_REQUEST_FAILURE = 'UPDATE_TIMESHEET_REQUEST_FAILURE';
export const UPDATE_TIMESHEET_REQUEST_SUCCESS = 'UPDATE_TIMESHEET_REQUEST_SUCCESS';

export const UPDATE_SYNC_STATUS = 'UPDATE_SYNC_STATUS';
